import { getGameState } from "@/utils/apiFunctions";
import { getMyRank, deleteGameState } from "@/utils/apiFunctions";
import CryptoJS from "crypto-js";
export default {
	data() {
		return {
			GAME_ENCRYPTION_KEY: "M3kyY2RYu9tVUZcU",
			gameState: false,
			gameOverState: true,
			gameType: this.$route.query.gameType,
			gameStatus: "Start Game",
			gameExpired: false,
			gameWon: false,
			showResume: false,
			gameOvered: true,
			showStatus: false,
			showMessage: "",
			rank: 0,
			gameStartMessage: "Start Game",
			gameData: null,
			wordOfDay: "",
			showWonMessage: "",
			gameLoading: true,
		};
	},
	async created() {
		this.getGameState(this.gameType);
		await this.getMyRank();
	},
	methods: {
		decryptWord(encryptedWord) {
			try {
				const encryptedData = CryptoJS.enc.Base64.parse(encryptedWord);

				// Extract IV (first 16 bytes) and ciphertext
				const iv = CryptoJS.lib.WordArray.create(encryptedData.words.slice(0, 4));
				const ciphertext = CryptoJS.lib.WordArray.create(encryptedData.words.slice(4));

				// Decrypt using AES-CBC
				const decrypted = CryptoJS.AES.decrypt(
					{ ciphertext },
					CryptoJS.enc.Utf8.parse(this.GAME_ENCRYPTION_KEY),
					{ iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
				);
				return decrypted.toString(CryptoJS.enc.Utf8);
			} catch (error) {
				console.error("Decryption failed:", error);
				return null;
			}
		},
		async getGameState(getType, isNewGame = false) {
			try {
				this.gameLoading = true;
				this.gameType = this.$route.query.gameType;
				// const deletes = await deleteGameState("crossword");
				// const deletes = await deleteGameState('sudoku');
				// const deletes = await deleteGameState('2048');
				// const deletes = await deleteGameState('wordle');
				const res = await getGameState(this.gameType);
				// this.gameState =true;
				if (res.status == 200) {
					this.gameWon =
						res.data?.data?.state?.wonGame ||
						res.data?.data?.state?.gameWon ||
						false;
					// if (this.gameType == "crossword") {
					// 	this.gameWon =
					// 		res.data?.data?.state?.wonGame ||
					// 		res.data?.data?.state?.gameWon ||
					// 		false;
					if (this.gameType == "crossword") {
						this.gameWon =
							res.data?.data?.state?.gameOver ||
							res.data.data.submitted ||
							false;
						if (this.gameWon) {
							this.showWonMessage = "YOU WON";
						} else {
							this.showWonMessage = "YOU LOST";
						}
					}
					this.gameOvered =
						res.data?.data?.state?.gameOver || res.data.data.submitted || false;
					if (isNewGame && this.gameOvered) {
						const deletes = await deleteGameState(this.gameType);
						if (deletes.status == 200) {
							this.getGameState(this.gameType);
						}
					}
					if (this.gameType == "2048") {
						if (this.gameWon) {
							this.showWonMessage = "YOU WON";
						} else {
							this.showWonMessage = "YOU LOST";
						}
						this.gameData = res.data.data.state?.game_data || 0;
					} else if (this.gameType == "wordle") {
						if (this.gameWon) {
							this.showWonMessage = "YOU WON";
						} else {
							this.showWonMessage = "YOU LOST";
						}
						const encryptedWord =
							res.data?.data?.state?.word ||
							res.data?.data?.state?.game_data.word;
						this.wordOfDay = this.decryptWord(encryptedWord); // Decrypt the word
						this.gameData = res.data?.data?.state?.guessedWords || 0;
					} else if (this.gameType == "sudoku") {
						if (this.gameWon) {
							this.showWonMessage = "YOU WON";
						} else {
							this.showWonMessage = "YOU LOST";
						}
						this.gameData = res.data?.data?.state?.board || 0;
					} else {
						this.gameData = Object.entries(
							res.data?.data?.state?.crossword || {}
						);
					}
					setTimeout(async () => {
						if (this.gameOvered) {
							this.showStatus = true;
						}
					}, 0);

					if (this.gameWon) {
						if (this.gameType == "wordle") {
							this.showMessage = `You Won. The word was "${this.wordOfDay}"`;
						} else {
							this.showMessage = "You Won";
						}
					} else {
						if (this.gameType == "wordle") {
							// this.showMessage="Uh-oh..you lost. The word was "+this.wordOfDay;
							this.showMessage = "The word was " + this.wordOfDay;
						} else {
							this.showMessage = "Uh-oh..you lost";
						}
					}
					if (!this.gameOvered) {
						this.showResume = true;
					}
					if (!this.gameOvered && this.gameData?.length > 0 || (this.gameType == "wordle" && Array.isArray(this.gameData))) {
						this.gameStartMessage = "Resume Game";
					}
				} else if (res.status == 400) {
					this.gameState = true;
				} else {
					if (this.gameType == "2048") {
						this.gameOverState = true;
						this.showResume = true;
						this.gameStartMessage = "Start Game";
					}
					this.gameOvered = false;
					this.showResume = true;
				}
			} catch (e) {
				if (e.response.status == 403 || e.response.status == 400) {
					this.gameState = true;
				}
			} finally {
				this.gameLoading = false;
			}
		},
		async getMyRank() {
			const res = await getMyRank(this.gameType);
			if (res.status == 200) {
				this.rank = res.data.data.rank;
			} else {
				this.rank = 0;
			}
		},
	},
};